export class AppInfo {
    id: string;
    platform: string = "";
    currentVersion: string = "";
    currentBuildNumber: number = 0;
    minVersion: string = "";
    minBuildNumber: number = 0;
    updatedAt: string = "";

    constructor(from?:AppInfo) {
        if(from) {
            this.id = from.id;
            this.platform = from.platform;
            this.currentVersion = from.currentVersion;
            this.currentBuildNumber = from.currentBuildNumber;
            this.minVersion = from.minVersion;
            this.minBuildNumber = from.minBuildNumber;
            this.updatedAt = from.updatedAt;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/appsInfo/app-info.ts